import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useT } from '@/i18n';
import { api } from '@/api/client';
import { formatDate, formatFileSize } from '@/lib/format';
export function AdminFileManager() {
    const { orgId, projectId } = useParams();
    const { t, lang } = useT();
    const [deliverables, setDeliverables] = useState([]);
    const [uploading, setUploading] = useState(false);
    useEffect(() => {
        if (projectId)
            api.deliverables.byProject(projectId).then(setDeliverables).catch(() => { });
    }, [projectId]);
    const handleDrop = useCallback(async (e) => {
        e.preventDefault();
        if (!projectId)
            return;
        const files = Array.from(e.dataTransfer.files);
        setUploading(true);
        for (const file of files) {
            const ext = file.name.split('.').pop() ?? 'bin';
            const name = file.name.replace(`.${ext}`, '');
            // Step 1: Create deliverable record
            const record = await api.deliverables.create({
                projectId,
                name,
                fileType: ext,
                fileSizeBytes: file.size,
            });
            // Step 2: Upload file content
            await api.deliverables.uploadFile(record.id, file);
        }
        setUploading(false);
        api.deliverables.byProject(projectId).then(setDeliverables);
    }, [projectId]);
    return (_jsxs("div", { children: [_jsxs(Link, { to: `/admin/clients/${orgId}/projects`, className: "text-sm text-stone-gray hover:text-warm-white mb-4 inline-block", children: ["\u2190 ", t.common.back] }), _jsx("h1", { className: "text-2xl font-bold mb-6", children: t.nav.files }), _jsx("div", { onDragOver: (e) => e.preventDefault(), onDrop: handleDrop, className: "border-2 border-dashed border-stone-gray/30 rounded-lg p-8 text-center mb-6 hover:border-amber-gold/50 transition-colors", children: _jsx("p", { className: "text-stone-gray text-sm", children: uploading ? t.common.loading : 'Drag & drop files here to upload' }) }), _jsx("div", { className: "space-y-3", children: deliverables.map((d) => (_jsxs("div", { className: "bg-deep-charcoal rounded-lg p-4 flex items-center justify-between", children: [_jsxs("div", { children: [_jsxs("h3", { className: "font-medium", children: [d.name, ".", d.file_type] }), _jsxs("p", { className: "text-sm text-stone-gray", children: [formatFileSize(d.file_size_bytes ?? 0), " \u00B7 v", d.version, " \u00B7 ", formatDate(d.created_at, lang)] })] }), _jsx("a", { href: api.deliverables.downloadUrl(d.id), className: "btn-secondary text-sm", children: t.common.download })] }, d.id))) })] }));
}
